enum BankAccConstants {
  GET_BANK_ACC_REQUEST = "GET_BANK_ACC_REQUEST",
  GET_BANK_ACC_SUCCESS = "GET_BANK_ACC_SUCCESS",
  GET_BANK_ACC_FAILURE = "GET_BANK_ACC_FAILURE",

  ADD_BANK_ACC_REQ = "ADD_BANK_ACC_REQ",
  ADD_BANK_ACC_SUCCESS = "ADD_BANK_ACC_SUCCESS",
  ADD_BANK_ACC_FAILURE = "ADD_BANK_ACC_FAILURE",

  EDIT_BANK_ACC_REQUEST = "EDIT_BANK_ACC_REQUEST",
  EDIT_BANK_ACC_SUCCESS = "EDIT_BANK_ACC_SUCCESS",
  EDIT_BANK_ACC_FAILURE = "EDIT_BANK_ACC_FAILURE",
}

export default BankAccConstants;
